export const FILE_NAME_REG_EXP = /^[a-zA-Z0-9_.\-()[\]{},& ]+$/;
